
import { handleError, error, receive, request } from './Utils';
import Swagger from 'swagger-client';
let SwaggerApi = new Swagger('/api/docs');

/**
 * 
 * @param {*} parameters 
 * @param {*} tag 
 * @param {*} func 
 * @param {*} action 
 * @param {*} callback 
 */
 export function callApi(parameters, tag, func, action, callback = () => { }) {
  return (dispatch) => {
    dispatch(request(action));
    SwaggerApi.then(client => {
      client.apis[tag][func](parameters).then(payload => {
        if (payload.ok) {
          dispatch(receive(action, payload.body));
          callback(null, payload.body);
        } else {
          handleError(dispatch, payload, action, callback);
        }
      }).catch((err) => {
        console.log(err);
        if(err.response && err.response.body && err.response.body.message){
          let myErr = { status: err.status, message: err.response.body.message }
          dispatch(error(action, myErr));
          callback(myErr);
        }else{
          dispatch(error(action, { status: 0, message: err.message }));
          callback(err);
        }
        
        
      });
    }).catch(err => {
      dispatch(error(action, { status: 0, message: err.message }));
      callback(err);
    });
  };
}


export default SwaggerApi;


// WEBPACK FOOTER //
// ./src/lib/SwaggerApi.js